export const styles = theme => ({
    '@media (min-width: 768px)': {
        container: {
            display: 'flex',
            flexFlow: 'column',
            minHeight: '100%',
        },
        headerContainerLive: {
            backgroundImage: `linear-gradient(to bottom, ${theme.colors.brand.yellow}, ${theme.colors.brand.pink})`,
            display: 'flex',
            justifyContent: 'center',
        },
        headerContainerDisabled: {
            backgroundImage: `linear-gradient(to bottom, ${theme.colors.light.darkgrey}, ${theme.colors.dark.dark4})`,
            display: 'flex',
            justifyContent: 'center',
        },
        headerContainerBlack: {
            backgroundColor: theme.colors.black,
            display: 'flex',
            justifyContent: 'center',
        },
        formContainer: {
            backgroundColor: theme.colors.dark.dark1,
            display: 'flex',
            flex: '1',
            justifyContent: 'center',
        },
    },
})
